<template>
	<div class="selector">
		<product-searcher ref="searcher" @change="select" />
		<div v-if="name" class="selector__selected">
			<span v-html="name" class="selector__selected__name" />
			<button
				class="btn-delete--only-icon selector__selected__delete"
				@click="deleteProduct"
			/>
		</div>
	</div>
</template>
<script>
	import ProductSearcher from '@/components/ProductSearcher2';

	export default {
		name: 'ProductSelector',
		components: {
			ProductSearcher,
		},
		props: {
			value: {
				type: Number,
				default: null,
			},
		},
		data() {
			return {
				name: '',
			};
		},
		watch: {
			value(value) {
				this.selectById(value);
			},
		},
		created() {
			this.selectById(this.value);
		},
		methods: {
			select(product) {
				this.name = product.name;
				this.$emit('input', product.idProduct);
				this.$emit('change', product);
			},
			deleteProduct() {
				this.name = '';
				this.$emit('input', null);
				this.$emit('change', null);
			},
			selectById(id) {
				if (id) {
					this.$refs.searcher.selectById(id);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	DIV.selector {
		.selector__selected {
			display: flex;
			width: 100%;
			height: 36px;
			padding-left: 12px;
			border: solid 1px #dfe6ee;
			align-items: center;
			justify-content: space-between;
		}

		.selector__selected__name {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.selector__selected__delete {
			width: 34px;
			height: 100%;
			border: 0;
			flex-shrink: 0;

			&:hover {
				outline: 1px solid #0099fa;
			}
		}
	}
</style>
